<template>
  <router-view />
</template>

<script>
export default {
  name: 'LieferscheineLayout',
};
</script>

<style></style>
